import { createReduxAsyncThunkWithoutErrorHandling } from 'shared/utils';
import { carsAPI } from 'entities/cars';

import { CARS_STATE } from '../../constants';

import { CarsLocationSharing, CarsLocationSharingForm } from '../../types';

export const addLocationSharing = createReduxAsyncThunkWithoutErrorHandling<CarsLocationSharing, CarsLocationSharingForm>(
  `${CARS_STATE}/addLocationSharing`,
  async (form) => {
    const { data } = await carsAPI.addCarsLocationSharing(form);
    return data;
  }
);
